const data = [{
    key: '1',
    target: '新增',
    name: '今日新增用户数'
}, {
    key: '2',
    target: '分享新增',
    name: '通过分享带来的新用户'
}, {
    key: '3',
    target: '分享系数',
    name: '分享新增 /（DAU - 分享新增）'
}, {
    key: '4',
    target: '活跃',
    name: '今日登陆过的用户数'
}, {
    key: '5',
    target: '次日留存',
    name: '新增用户第2日再次登陆人数'
}, {
    key: '6',
    target: 'N日留存',
    name: '新增用户第N日再次登陆人数'
}, {
    key: '7',
    target: '关注数',
    name: '公众号关注人数'
}, {
    key: '8',
    target: '关注率',
    name: '今日活跃中的关注人数 / 活跃'
}, {
    key: '9',
    target: '收入',
    name: '今日总收入'
}, {
    key: '10',
    target: '付费率',
    name: '付费人数 / DAU'
}, {
    key: '11',
    target: 'ARPU',
    name: '收入 / DAU'
}, {
    key: '12',
    target: 'ARPPU',
    name: '收入 / 付费用户数'
}, {
    key: '13',
    target: '分享次数',
    name: '分享总次数'
}, {
    key: '14',
    target: '分享渗透率',
    name: '分享用户数 / DAU'
}, {
    key: '15',
    target: '付费留存',
    name: '付费用户的次日登陆人数'
}, {
    key: '16',
    target: '未关注留存',
    name: '未关注用户的次日登陆人数 (待实现)'
}, {
    key: '17',
    target: '未付费留存',
    name: '未付费用户的次日登陆人数'
}, {
    key: '18',
    target: '分享新增占比',
    name: '分享新增 / 新增用户数'
}, {
    key: '19',
    target: '老用户次留',
    name: '活跃用户的次日登陆人数 (待实现)'
}, {
    key: '20',
    target: '新增付费率',
    name: '新增付费用户数 / 活跃人数'
}, {
    key: '21',
    target: 'LtvN',
    name: '新增用户在N日生命周期价值'
}, {
    key: '22',
    target: '有效分享率',
    name: '带来新增分享 / 分享人数'
}, {
    key: '23',
    target: '创角数',
    name: '创建角色用户数 (待实现)'
}, {
    key: '24',
    target: '创角率',
    name: '创角用户 / 新增 (待实现)'
}, {
    key: '25',
    target: '新增用户分享率',
    name: '新增分享用户 / 新增用户'
}, {
    key: '26',
    target: '新增用户传播系数',
    name: '新增分享用户/（新增用户-新增分享用户）'
}, {
    key: '27',
    target: '授权率',
    name: '授权成功用户 / 新增'
}, {
    key: '28',
    target: 'android(ios)次日留存',
    name: '安卓(IOS)用户的次日留存'
}, {
    key: '29',
    target: 'android(ios)收入',
    name: '安卓(IOS)用户的收入'
}, {
    key: '30',
    target: 'android(ios)所有订单数',
    name: '安卓(IOS)所有充值订单数'
}, {
    key: '31',
    target: 'android(ios)成功订单数',
    name: '安卓(IOS)充值成功订单数'
}, {
    key: '32',
    target: 'android(ios)所有订单用户数',
    name: '安卓(IOS)充值用户数'
}, {
    key: '33',
    target: 'android(ios)成功订单用户数',
    name: '安卓(IOS)充值成功用户数'
}, {
    key: '34',
    target: '次日关注留存',
    name: '关注公众号用户次日留存'
}, {
    key: '35',
    target: 'N日关注留存',
    name: '关注公众号用户N日留存'
}, {
    key: '36',
    target: '新增', 
    name: '今日新增用户数' 
}, {
    key: '37',
    target: '老用户次留', 
    name: 'DOU(活跃-新增)用户的次日登陆人数' 
}, {
    key: '38',
    target: '总广告arpu', 
    name: '(banner广告收入 + 视频广告收入) / 活跃' 
}, {
    key: '39',
    target: 'DOU', 
    name: '活跃人数 - 新增人数' 
}, {
    key: '40',
    target: '活跃用户公众号激活比', 
    name: '激活公众号推送的用户数 / DAU' 
}, {
    key: '41',
    target: '活跃用户公众号关注比', 
    name: '关注公众号的用户数 / DAU' 
}, {
    key: '42',
    target: '流失用户数', 
    name: '最近3未登录过游戏的人数' 
}, {
    key: '43',
    target: '回流用户数', 
    name: '已经流失的用户在当天重新登录游戏的人数' 
}, {
    key: '44',
    target: '回流N日留存', 
    name: '回流用户第N日再次登陆人数' 
}, {
    key: '45',
    target: '分享总人数', 
    name: '产生分享行为的用户数' 
}];

export default data;